const images = {
  navBarLogo: require('../assets/images/NewImages/HomePage/NavbarLogo2.png'),
  navBarLogo2: require('../assets/images/NewImages/HomePage/NavbarLogo2.png'),
  navBarGiftIcon: require('../assets/images/NavBar/gifticon.png'),
  homePageBanner1: require('../assets/images/HomePage/homePageBanner1.svg').default,
  homePageLearningIcon1: require('../assets/images/HomePage/learningIcons/calander.png'),
  homePageLearningIcon2: require('../assets/images/HomePage/learningIcons/teacher.png'),
  homePageLearningIcon3: require('../assets/images/HomePage/learningIcons/pen.png'),
  homePageLearningIcon4: require('../assets/images/HomePage/learningIcons/hand.png'),
  homePageLearningIcon5: require('../assets/images/HomePage/learningIcons/notebook.png'),
  homePageLearningIcon6: require('../assets/images/HomePage/learningIcons/hands.png'),
  homePageLearningIcon7: require('../assets/images/HomePage/learningIcons/arrow.png'),
  homePageLearningIcon8: require('../assets/images/HomePage/learningIcons/rocket.png'),
  homePageAIIcons1: require('../assets/images/HomePage/AiIcons/Frame.png'),
  homePageAIIcons2: require('../assets/images/HomePage/AiIcons/Frame-1.png'),
  homePageAIIcons3: require('../assets/images/HomePage/AiIcons/Frame-2.png'),
  homePageAIImage: require('../assets/images/HomePage/AiIcons/AiImage.png'),
  homePageCourseIcon1: require('../assets/images/HomePage/CoursesIcon/1.png'),
  homePageCourseIcon2: require('../assets/images/HomePage/CoursesIcon/2.png'),
  homePageCourseIcon3: require('../assets/images/HomePage/CoursesIcon/3.png'),
  fundationCourseUserImage:
    require('../assets/images/User/Home/Courses/userImageFundationCourse.svg').default,
  homePageHandWrittenNotes: require('../assets/images/HomePage/HandWrittenNotes.png'),
  testSeriesImage: require('../assets/images/HomePage/TestSeriesImage.png'),
  pyqImage: require('../assets/images/HomePage/PYQImage.png'),
  homePageComunityImage1: require('../assets/images/HomePage/Community/Frame.png'),
  homePageComunityImage2: require('../assets/images/HomePage/Community/Frame-1.png'),
  homePageComunityImage3: require('../assets/images/HomePage/Community/Frame-2.png'),
  homePageComunityImage4: require('../assets/images/HomePage/Community/Vector.png'),
  hompageDownloadAppImage: require('../assets/images/HomePage/iphonePic.png'),
  loginPageBackgroundImage: require('../assets/images/Login/loginBackground.svg').default,
  goalsPageCourseImage1: require('../assets/images/Goals/image.svg').default,
  goalsPageCourseImage2: require('../assets/images/Goals/image-1.svg').default,
  goalsPageCourseImage3: require('../assets/images/Goals/image-2.svg').default,
  UserSidebarIcons: require('../assets/images/User/Sidebar/Frame.svg').default,
  UserSidebarIcons1: require('../assets/images/User/Sidebar/Frame-1.svg').default,
  UserSidebarIcons2: require('../assets/images/User/Sidebar/Frame-2.svg').default,
  UserSidebarIcons3: require('../assets/images/User/Sidebar/Frame-3.svg').default,
  UserSidebarIcons4: require('../assets/images/User/Sidebar/Frame-4.svg').default,
  UserSidebarIcons5: require('../assets/images/User/Sidebar/Frame-5.svg').default,
  UserSidebarIcons6: require('../assets/images/User/Sidebar/Frame-6.svg').default,
  UserSidebarIcons7: require('../assets/images/User/Sidebar/Frame-7.svg').default,
  UserSidebarIcons8: require('../assets/images/User/Sidebar/Frame-8.svg').default,
  UserSidebarIcons9: require('../assets/images/User/Sidebar/Frame-9.svg').default,
  UserSidebarIcons10: require('../assets/images/User/Sidebar/Frame-10.svg').default,
  UserSidebarIcons11: require('../assets/images/User/Sidebar/Frame-11.svg').default,
  UserSubjectsImage: require('../assets/images/User/subjectImage.png'),

  UserTestSubmitted: require('../assets/images/User/SkillsPage/testCompleted.png'),
  UserTestTrophy: require('../assets/images/User/TestWithVideo/trophy.png'),
  footerLogo: require('../assets/images/HomePage/footerLogo.svg').default,

  userDashboardTopBanner: require('../assets/images/User/topBanner.svg').default,
  userDashboardSkillsBanner: require('../assets/images/User/SkillsPage/skillsPage.svg').default,
  menubarIcon1: require('../assets/images/User/MenuBar/1.jpeg'),
  menubarIcon2: require('../assets/images/User/MenuBar/2.jpeg'),
  menubarIcon3: require('../assets/images/User/MenuBar/3.jpeg'),
  menubarIcon4: require('../assets/images/User/MenuBar/4.png'),
  menubarIcon5: require('../assets/images/User/MenuBar/5.jpeg'),
  userHomeCoursesImage1: require('../assets/images/User/Home/Courses/image-1.svg').default,
  userHomeCoursesImage2: require('../assets/images/User/Home/Courses/image-2.svg').default,
  userHomeRewardsImage1: require('../assets/images/User/Home/Rewards/image-1.png'),
  userHomeRewardsImage2: require('../assets/images/User/Home/Rewards/image-2.png'),
  userHomeTopContentImage1: require('../assets/images/User/Home/TopConent/image.png'),
  userAboutExamImage: require('../assets/images/User/AboutExam/image-1.svg').default,
  userTestWithVideoImage: require('../assets/images/User/TestWithVideo/testPageImage.png'),
  userHandWrittenNotesImage: require('../assets/images/User/HandWrittenNotes/HandWrittenNotes.png'),
  userHandWrittenNotesImage2: require('../assets/images/User/HandWrittenNotes/studentImage.png'),
  userPYQsWithNotesImages1: require('../assets/images/User/PYQsWithVideo/PYQswithVideoBanner.svg')
    .default,
  userStudyPlannerAiImage1: require('../assets/images/User/StudyPlannerAi/Page2/image-1.svg')
    .default,
  userStudyPlannerAiImage2: require('../assets/images/User/StudyPlannerAi/Page2/image-2.svg')
    .default,
  userStudyPlannerAiImage3: require('../assets/images/User/StudyPlannerAi/Page2/image-3.svg')
    .default,
  userStudyPlannerAiImage4: require('../assets/images/User/StudyPlannerAi/Page2/image-4.svg')
    .default,
  userSettingsImage: require('../assets/images/User/Settings/profileImage.svg').default,
  userSettingsImage1: require('../assets/images/User/Settings/Dashboard Roadmap/1.png'),
  userSettingsImage2: require('../assets/images/User/Settings/Dashboard Roadmap/2.png'),
  userSettingsImage3: require('../assets/images/User/Settings/Dashboard Roadmap/3.png'),
  userSettingsImage4: require('../assets/images/User/Settings/Dashboard Roadmap/4.png'),
  userSettingsImage5: require('../assets/images/User/Settings/Dashboard Roadmap/5.png'),
  userSettingsImage6: require('../assets/images/User/Settings/Dashboard Roadmap/6.png'),
  userSettingsImage7: require('../assets/images/User/Settings/Dashboard Roadmap/7.png'),
  userAllDashboardImage: require('../assets/images/User/AllDashboard/videoPic.png'),
  userAllDashboardTestImage: require('../assets/images/User/AllDashboard/testPic.png'),
  userAllDashboardPracticeImage: require('../assets/images/User/AllDashboard/practiceAnalysis.png'),
  userNavbarLogo: require('../assets/images/User/mainItems/siteLogo.svg').default,
  userNavbarHome: require('../assets/images/User/mainItems/logoHome.png'),
  userNavbarCart: require('../assets/images/User/mainItems/abc.png'),
  userCourseViewDashboardImage: require('../assets/images/User/Home/Courses/viewDashboard.svg')
    .default,
  userTestUserPageImage1: require('../assets/images/User/TestWithVideo/testPageImages1/1.png'),
  userTestUserPageImage2: require('../assets/images/User/TestWithVideo/testPageImages1/2.png'),
  userTestUserPageImage3: require('../assets/images/User/TestWithVideo/testPageImages1/3.png'),
  userTestUserPageImage4: require('../assets/images/User/TestWithVideo/testPageImages1/4.png'),
  userTestUserPageImage5: require('../assets/images/User/TestWithVideo/testPageImages1/5.png'),
  userTestUserPageImage6: require('../assets/images/User/TestWithVideo/testPageImages1/6.png'),
  userAboutPageImage: require('../assets/images/HomePage/aboutImage.png'),
  userAboutPageTeacherImage: require('../assets/images/HomePage/teachers/image.png'),
  userAboutPageTeacherImage2: require('../assets/images/HomePage/teachers/image-1.png'),
  userAboutPageTeacherImage3: require('../assets/images/HomePage/teachers/image-2.png'),
  userAboutPageTeacherImage4: require('../assets/images/HomePage/teachers/image-3.png'),
  userAboutPageDownloadBtn1: require('../assets/images/HomePage/downloadButton/image.png'),
  userAboutPageDownloadBtn2: require('../assets/images/HomePage/downloadButton/image 4.png'),
  userTickImage: require('../assets/images/Login/tickImage.png'),
  userStudyModal: require('../assets/images/Login/modalImageMain.png'),
  userCommingSoon: require('../assets/images/CommingSoon.png'),
  userCommingSoon2: require('../assets/images/other/comingsoon.png'),

  newHomePageTopBannerImage: require('../assets/images/NewImages/HomePage/TopBanner.svg').default,
  newAboutPageBanner: require('../assets/images/NewImages/HomePage/AboutExam/banner.png'),
  newMainLogo: require('../assets/images/NewImages/HomePage/NavbarLogo2.png'),
  newHomePageCourseImage1: require('../assets/images/NewImages/HomePage/Courses/1.svg').default,
  newHomePageCourseImage2: require('../assets/images/NewImages/HomePage/Courses/2.svg').default,
  newHomePageCourseImage3: require('../assets/images/NewImages/HomePage/Courses/3.svg').default,
  newHomePageCourseImage4: require('../assets/images/NewImages/HomePage/Courses/4.svg').default,
  newHomePageCourseImage5: require('../assets/images/NewImages/HomePage/Courses/5.svg').default,
  newHomePageCourseImage6: require('../assets/images/NewImages/HomePage/Courses/6.svg').default,
  newHomePageBrandsImage1: require('../assets/images/NewImages/HomePage/Brands/1.svg').default,
  newHomePageBrandsImage2: require('../assets/images/NewImages/HomePage/Brands/2.svg').default,
  newHomePageBrandsImage3: require('../assets/images/NewImages/HomePage/Brands/3.svg').default,
  newHomePageBrandsImage4: require('../assets/images/NewImages/HomePage/Brands/4.svg').default,
  newHomePageBrandsImage5: require('../assets/images/NewImages/HomePage/Brands/5.svg').default,
  newHomePageBrandsImage6: require('../assets/images/NewImages/HomePage/Brands/6.svg').default,

  newHomePageCommunityImage: require('../assets/images/NewImages/HomePage/BackgroundImageItems.svg')
    .default,
  newHomePageCommunityImage1: require('../assets/images/NewImages/HomePage/Community/1.png'),
  newHomePageCommunityImage2: require('../assets/images/NewImages/HomePage/Community/2.svg')
    .default,
  newHomePageCommunityImage3: require('../assets/images/NewImages/HomePage/Community/3.svg')
    .default,
  newHomePageCommunityImage4: require('../assets/images/NewImages/HomePage/Community/4.svg')
    .default,
  newHomePageCommunityImage5:
    require('../assets/images/NewImages/HomePage/Community/titleImage.svg').default,
  newHomePageHowWeWorkImage1: require('../assets/images/NewImages/HomePage/HowWeWork/howWeWorkImage.png'),
  newHomePageExploreCourseImage1: require('../assets/images/NewImages/HomePage/ExploreCourses/1.png'),
  newHomePageExploreCourseImage2: require('../assets/images/NewImages/HomePage/ExploreCourses/2.png'),
  newHomePageExploreCourseImage3: require('../assets/images/NewImages/HomePage/ExploreCourses/3.png'),
  newHomePageExploreCourseImage4: require('../assets/images/NewImages/HomePage/ExploreCourses/4.png'),
  newHomePageLoginModalImage: require('../assets/images/NewImages/HomePage/Modal/loginIocn.svg')
    .default,
  newHomePageLoginModalImage2:
    require('../assets/images/NewImages/HomePage/Modal/loginBackground.svg').default,
  newCoursePage1Image1: require('../assets/images/NewImages/CoursePage/Page1/1.svg').default,
  newCoursePage1Image2: require('../assets/images/NewImages/CoursePage/Page1/2.svg').default,
  newCoursePage1Image3: require('../assets/images/NewImages/CoursePage/Page1/3.svg').default,
  newCoursePage4Image1: require('../assets/images/NewImages/CoursePage/Page4/courseImage1.svg')
    .default,
  newHandwrittenNotesImage1: require('../assets/images/NewImages/HandwrittenNotes/1.svg').default,
  newTestSectionImage1: require('../assets/images/NewImages/TestSection/1.png'),
  newPlacementPageImage1: require('../assets/images/NewImages/PlacementPage/1.svg').default,
  newSettingDashboardImage1: require('../assets/images/NewImages/Settings/1.svg').default,
  newSettingDashboardImage2: require('../assets/images/NewImages/Settings/2.svg').default,
  newSettingDashboardImage3: require('../assets/images/NewImages/Settings/3.svg').default,
  newSettingDashboardImage4: require('../assets/images/NewImages/Settings/4.svg').default,
  newSettingDashboardImage5: require('../assets/images/NewImages/Settings/5.svg').default,
  newSettingDashboardImage6: require('../assets/images/NewImages/Settings/6.svg').default,
  newSettingDashboardImage7: require('../assets/images/NewImages/Settings/7.svg').default,
  newStudyPlannerPage1Image1: require('../assets/images/NewImages/StudyPlannerAi/1.svg').default,
  newStudyPlannerPage1Image2: require('../assets/images/NewImages/StudyPlannerAi/2.svg').default,
  newStudyPlannerPage1Image3: require('../assets/images/NewImages/StudyPlannerAi/3.svg').default,
  newStudyPlannerPage1Image4: require('../assets/images/NewImages/StudyPlannerAi/4.svg').default,
  newDashboardImage1: require('../assets/images/NewImages/DashboardPage/1.svg').default,
  newDashboardUserImage: require('../assets/images/NewImages/userImage2.png'),
  newDashboardUserImage2: require('../assets/images/NewImages/DashboardPage/2.svg').default,
  newDashboardUserMainAboutImage1: require('../assets/images/NewImages/MainAbout/1.svg').default,
  newDashboardUserMainAboutImage2: require('../assets/images/NewImages/MainAbout/2.svg').default,
  newDashboardUserMainAboutImage3: require('../assets/images/NewImages/MainAbout/3.svg').default,
  newDashboardUserMainAboutImage4: require('../assets/images/NewImages/MainAbout/4.svg').default,
  newSubjectImage1: require('../assets/images/NewImages/Subjects/subject.jpg'),
  newStudyPlannerAiBannerImage: require('../assets/images/Banners/StudyPlannerBanner.png'),
  newAboutPageBannerImage: require('../assets/images/Banners/AboutPage.png'),
  newAboutPageBannerCoursePageImage: require('../assets/images/Banners/CoursePage.png'),
  newTestSeriesImage1Image: require('../assets/images/Banners/TestSeries.png'),
  newCommunityBannerImage: require('../assets/images/Banners/CommunityBanner.png'),
  newPYQBannerImage: require('../assets/images/Banners/PYQBanner.png'),
  userDashboardImageHome: require('../assets/images/Banners/userHomePage.png'),
};

export default images;
